import { Response } from 'shared/models/general.ts'

import { clientApi } from '../clientApi'

import { IScanDocument } from './model'

export const ScanDocument = {
  scanUserDocument(params: FormData) {
    return clientApi.post<Response<IScanDocument>>(
      '/scan-document-data',
      params,
      {
        adapter: 'fetch',
      },
    )
  },
}
